import { cva } from 'class-variance-authority';
/** 필드형 Select Trigger. 높이는 --control-height-* (rules-tokens). */
const selectTriggerBase = "border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-full min-w-0 items-center justify-between space-x-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:min-w-0 *:data-[slot=select-value]:flex-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:space-x-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4";
const selectTriggerSizeMap = {
    default: 'h-[length:var(--control-height)]',
    md: 'h-[length:var(--control-height-md)]',
    sm: 'h-[length:var(--control-height-sm)]',
    lg: 'h-[length:var(--control-height-lg)]',
};
export const selectTriggerCva = {
    variants: {
        size: selectTriggerSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const selectTriggerVariants = cva(selectTriggerBase, selectTriggerCva);
export const selectTriggerSizeKeys = Object.keys(selectTriggerCva.variants.size);
//# sourceMappingURL=select-trigger.cva.js.map